import React from 'react';
import { Sprout, Zap, BriefcaseBusiness, Presentation } from 'lucide-react';

const cases = [
  {
    icon: Sprout,
    title: 'Pemula',
    desc: 'Baru memulai dunia trading? Tradiora menyediakan semua yang Anda butuhkan untuk belajar dari nol.',
    benefits: [
      'Akademi komprehensif dari dasar',
      'Paper trading tanpa risiko',
      'Mentoring pendamping',
      'Komunitas yang suportif',
    ],
    accent: '#0C8F86',
    gradient: 'linear-gradient(145deg, #0a1628, #0f2338)',
  },
  {
    icon: Zap,
    title: 'Trader Aktif',
    desc: 'Tingkatkan performa trading Anda dengan AI analysis real-time dan diskusi strategi komunitas.',
    benefits: [
      'AI analysis & sentimen pasar',
      'Data real-time saham & crypto',
      'Diskusi strategi dengan trader lain',
      'Investment journal & tracking',
    ],
    accent: '#58bd7d',
    gradient: 'linear-gradient(145deg, #0a1628, #0f2822)',
  },
  {
    icon: BriefcaseBusiness,
    title: 'Investor',
    desc: 'Kelola portofolio investasi jangka panjang dengan analisis fundamental dan tracking otomatis.',
    benefits: [
      'Analisis fundamental mendalam',
      'Portfolio tracking otomatis',
      'Laporan performa berkala',
      'Rekomendasi diversifikasi aset',
    ],
    accent: '#8b5cf6',
    gradient: 'linear-gradient(145deg, #0a1628, #150f2e)',
  },
  {
    icon: Presentation,
    title: 'Mentor',
    desc: 'Bagikan keahlian dan bangun penghasilan sebagai mentor trading profesional di Tradiora.',
    benefits: [
      'Dashboard mentor eksklusif',
      'Manajemen kelas & siswa',
      'Materi ajar yang siap pakai',
      'Program monetisasi & reward',
    ],
    accent: '#f59e0b',
    gradient: 'linear-gradient(145deg, #0a1628, #1f1810)',
  },
];

function UseCases() {
  return (
    <section className="use-cases" style={{ padding: '100px 0', background: 'var(--bg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 48 }}>
              <h3 className="heading">Dibuat untuk Semua Level</h3>
              <p className="fs-20" style={{ color: 'var(--text)', maxWidth: 560, margin: '12px auto 0' }}>
                Apapun pengalaman trading Anda, Tradiora memiliki tools dan fitur yang sesuai kebutuhan.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {cases.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="col-xl-3 col-lg-6 col-md-6"
                data-aos="fade-up"
                data-aos-delay={index * 100}
                style={{ marginBottom: 24 }}
              >
                <div style={{
                  background: item.gradient,
                  borderRadius: 20,
                  padding: '34px 26px',
                  height: '100%',
                  border: `1px solid ${item.accent}20`,
                  transition: 'all 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                  className="use-case-card"
                >
                  {/* Accent glow */}
                  <div style={{
                    position: 'absolute', top: -40, right: -40,
                    width: 120, height: 120, borderRadius: '50%',
                    background: `radial-gradient(circle, ${item.accent}15 0%, transparent 70%)`,
                    pointerEvents: 'none',
                  }} />

                  <div style={{
                    width: 56, height: 56, borderRadius: 14,
                    background: `${item.accent}18`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    marginBottom: 18,
                  }}>
                    <Icon size={26} color={item.accent} />
                  </div>
                  <h5 style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
                    {item.title}
                  </h5>
                  <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.7, marginBottom: 18 }}>
                    {item.desc}
                  </p>
                  <ul style={{ padding: 0 }}>
                    {item.benefits.map((b, i) => (
                      <li key={i} style={{
                        color: 'rgba(255,255,255,0.7)', fontSize: 13,
                        marginBottom: 10, display: 'flex', alignItems: 'center', gap: 10,
                      }}>
                        <span style={{
                          width: 18, height: 18, borderRadius: '50%',
                          background: `${item.accent}20`, color: item.accent,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: 9, flexShrink: 0,
                        }}>✓</span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default UseCases;
